import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJHeader from "../view/FJHeader";
import {FJCloudAction, FJExportVideoAction, FJSaveAction, FJUserAction} from "../../../redux/action/FJRoot.action";
import FJCanvasStore from "../../../store/FJCanvasStore";
import FJUtil from "../../../util/FJUtil";
import key from 'keymaster'

class FJHeaderContainer extends Component {

	componentDidMount() {
		if (window.fjuser && window.fjuser.addListener && window.fjuser.eventType) {
			let {
				login,
				register,
				logout,
				hideRegisterPanel,
				hideLoginPanel,
				showLoginPanel,
				showRegisterPanel
			} = window.fjuser.eventType;
			window.fjuser.addListener(login, this.onLoginAndRegisterCallback);
			window.fjuser.addListener(register, this.onLoginAndRegisterCallback);
			window.fjuser.addListener(logout, this.onLogoutCallback);
			window.fjuser.addListener(hideRegisterPanel, this._hidePanel);
			window.fjuser.addListener(hideLoginPanel, this._hidePanel);
			window.fjuser.addListener(showLoginPanel, this._showPanel);
			window.fjuser.addListener(showRegisterPanel, this._showPanel);
		}

	// 	window.projectData = {
	// 		"id": "9",
	// 		"key": "f827236d9e5149f28d23fe8f90c3735c",
	// 		"uid": "352",
	// 		"name": "999",
	// 		"version": "3",
	// 		"createTime": "2021-11-18 02:54:50",
	// 		"updateTime": "2021-11-18 02:57:02",
	// 		"ratioType": "RATIO_LANDSCAPE",
	// 		"mainLayerVolume": 1,
	// 		"layer": "eyJtYWluTGF5ZXIiOlsiMTAyMzcyNDYtNWI5ZS00MDZhLWJlNDgtODQyYjNjZmIwMDJlIiwiZTI5NzJlOTctNTVlNi00NzY0LWJmNzUtN2JiYzcxNjAyOGPEJ2E0ZGUzNDJmLTM3NDMtNDBkNS04NjgxLWNhNjY4ZGFmMDU2NyIsIjhiOWI1NzA5LTgyY2YtNGFhNS05MjBkLWZjNjg5NjUyZGUyMCIsImRjNzY1NWYxLTkxZGEtNDcwNi1hODk3LTA4ZjhlODFmMTZlxE5jOWQ1YmVkYi04ZTViLTRhOGYtYWZiZS04YWEzNmY1OGFhNzgiLCIxODg1ZWIxMC02M2I1LTRlY2ItODU2Yy05YTEyOTFhNjZlYjnEJzRmZDliODYtNjNhYS00YjVlLThkNzItMGE0OWVhYjJhZjjEJ2RlYzRjOWFkLWM0NDYtNGQyMi1iOThjLTQ2MmI5MDVkODM3NyJdLCJzdWLoAWzGDkF1ZGlvyRN9",
	// 		"graphs": "W3siY3JvcFR5cGUiOiJTUVVBUkUiLMUUUmVsYXRpdmVSZWN0Ijp7IngiOjAsInnFBndpZHRoIjoxLCJoZWlnaHQiOjF9LCJy3zLSMnTGeFZJREVPIiwiaWQiOiIxMDIzNzI0Ni01YjllLTQwNmEtYmU0OC04NDJiM2NmYjAwMmUiLCJvcGFjaXR5xVNhbmdsZcVnZmxpcFjFFMQKWcUKbmFtxGUiLCJzb3VyY2VJxGYyYmMyMmQ0ZTRmMzAyNDIxMWNlNGIzNTUwMGZkNDYyMGE3MDY2MDYyOWQ3YTM1YmUwOTQ4MjNmMjRiNDc2Yzc5Iiwidm9sdcRaMC44LCJzdGFydFRpxBAzNC40NSwiZW5kxhA2NC45NSwiZGVsYeYBDG9yaWdpbkR1cmF0aW9uIjoyNjEuNDHIGFNpemXkAT7nATI1MTLqATQyODh9LCJzcGVlZOYA5WlsdGVyxC7nAUpub27kAR1pbnRlbnPpAR9j5AGWIjp0cnVlfSwiYWRqdXN0Rsk7ZXhwb3N1cuYBQWJyxGpuZXNzxQ90ZW1wZXJhdMgfdGludMUJc8QU5wDAMCwiY29udHJhc8YcaGlnaGzER8ZEc2hhZG93xgx2aWduZXR0xk3tAJh9LP8Ci/8CWf8Ci98y9gKLZTI5NzJlOTctNTVlNi00NzY0LWJmNzUtN2JiYzcxNjAyOGP/Aov/AovlAotjYmM2NThmMjQzYWFkMjhlMTI5ZDZhNjM2MWQyZGRlZDYxNjM2YWQxYjc2ZTE0Y2UzZTgxZDVkMjUwODA0Zv0CizbuAooxOC416gKKMzAuNfICjTkzLjHkAnP/Ao3/Ao3/Ao3/Ao3/Ao3/Ao3/Ao3/Ao3/Ao3/Ao3/Ao3fMv0CjWE0ZGUzNDJmLTM3NDMtNDBkNS04NjgxLWNhNjY4ZGFmMDU2N/8Cjf8Cjf8FGP8FGP8FGCI6MTUxLjfuAo/GEecCkDQyLjb/BR3/ApD/ApD/ApD/ApD/ApD/ApD/ApD/ApD/ApD/Al7/ApDfMvgCkDhiOWI1NzA5LTgyY2YtNGFhNS05MjBkLWZjNjg5NjUyZGUyMP8CkP8CkMRmNmNlYWM3M2I4ZTZjZDE0NTA2MTZlZTc1YWJlZTM0NGFjNDVmNzUzODc3NzIxMGMwM2U2ZDIzMzI3ODNlZDQ25AHw+AKQMOwCizQuNDY05AUt5wKNN/UCjcon9QKPMTky5AHi6AE5MDgw/wKR/wKR/wKR/wKR/wKR/wKR/wKR/wKR/wJf/wKRxDIuMzQxMzTPODAuMzE3M+sD9PgCnWRjNzY1NWYxLTkxZGEtNDcwNi1hODk3LTA4ZjhlODFmMTZl/wUt/wKd5QKdMzY2NzdhMWRiNTlkZjAxOTcyNzhhMDQwYjFhMmNjM2U5NTA3NmFiZTg4ZTNmODI4NDJlMmJhNjdm5AfRYmFj/wKd6AKdNDUuNzY2NTMx6QKeODcuMPMCn8sp9QKgNDjrAp84NP8FL/8Cnv8Cnv8Cnv8Cnv8Cnv8Cnv8Cnv8Cnv8Cnt8y+AKSYzlkNWJlZGItOGU1Yi00YThmLWFmYmUtOGFhMzZmNThhYTc4/wKS/wKSxWZmNjI2ZTU4MmE1NWJkY2U5YmExNDE3NjNlZjcxNzlhNjU1NjE4OWYxOTFjYWI5ZjhlZjJmMGI0ODgyNGRhYTP/ApLoApIzMS41M+oFLTEzMi44M/ICkMgn/wUt/wUt/wKP/wKP/wKP/wKP/wKP/wKP/wKP/wKP/wKP3zL/Ao8xODg1ZWIxMC02M2I1LTRlY2ItODU2Yy05YTEyOTFhNjZlYuQJzP8Cj/8CjyI5NjhiNGRjY+QCYzJkMjI4YzY0YzYzOTE1ZTU2MTUxYjkyZmJlMDA1MTBlMTdhNWIyNDljZjdmZTg2N2EwMmT/Ao/pBSEyLjA0OOoCjzY0LjM38wUfxyf/Ao//Ao//Ao//Ao//Ao//Ao//Ao//Ao//Ao//Ao//Ao/MMuQHvDk3Ms855Ae9NjA1Nv8CneQCnTRmZDliODYtNjNhYS00YjVlLThkNzItMGE0OWVhYjJhZjj/Ap3/Ap3lAp0wNzdmYzg3NTNlOWE1ODQwYmNhYjVjNDQzZjNkZWY0MzkzZWNlMzBjMmVjYjY4ZmNmZjU1ODZlMzZlZjUxNjH/ClvqClsyLjM3NTAx6ge+MjA2LjTpD2PrCl7KKvYCozDsB8DkArH/AqP/AqP/AqP/AqP/AqP/AqP/AqP/AqP/AqP9AqNudWxs9wo1ZWM0YzlhZC1jNDQ2LTRkMjItYjk4Yy00NjJiOTA1ZDgzN/8KNf8Cd+UCdzVmMDcyYjhmMmI1YmJlMzUxYTM0YWMwMjA0ZjQyYzE2MDA2OTMyMmY1NzQzOGPkAv1iYWFmOTE1YTdjY2T/BRTqAnc4xBzoAnExxQ7wAnDLFe8CausCZ/8CZP8CZP8CZP8CZP8CZP8CZP8CZH1d",
	// 		"mediaLibrary": "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",
	// 		"transitions": "W10=",
	// 		"watermark": "eyJhY3RpdmVUeXBlIjoiV0FURVJNQVJLX1RFWFQiLCJ3YXRlcm1hcmtUZXh0Ijp7ImNyb3DHLVNRVUFSRSIsxRRSZWxhxElSZWPFKHgiOjAsInnFBndpZHRoIjoxLCJoZWlnaHQiOjF9LCJyzTJudWxsLCJ09wCHaWQiOiJiYmM0NzNjNy04YzU4LTQ4NmItOTQ2OC1hMTc3OTZiZjA3NDEiLCJvcGFjaXTEei41LCJhbmdsZeUAhmZsaXBY5QCGxApZxQpuYW3EcCIsImZvbnRGYW1pbHkiOiJNb250c2VycmF0xxpCb2xkIjpmYWxzZcYRSXRhbGljzRNDb2xvciI6IiNGxQHHOlNpemUiOjE2LCJsaW5lSOgBACwiYWxpZ25tZW50IjoiY2VudGVyIiwidGV4dERhdGEiOltdLCJwb3NpdGlvbiI6IkxFRlRfVE9QIiwic8ZSfesBnUltYWdl5gFEfQ==",
	// 		"editor": ""
	// };

		this.props.dealCloudZone();
		this.props.loadForOnline(window.projectData);
		this._unsubscribable = window.FJEvent.subscribe('UPDATE_LOGIN_STATUS', () => {
			this.props.setLoginStatus(FJUtil.isLogin());
		});
	};

	componentWillUnmount() {
		this._unsubscribable();
	}

	onLoginAndRegisterCallback = (result, response) => {
		if (result) {
			this.props.setLoginStatus(true);
			// FJCanvasStore.executeSync(FJCanvasStore.command.SAVE_FOR_ONLINE);
		}
	};

	onLogoutCallback = (result, response) => {
		if (result) {
			this.props.setLoginStatus(false)
		}
	};

	onSignUp = () => {
		FJUtil.showRegisterPanel();
	};

	/**
	 * @description 显示面板的时候
	 * @private
	 */
	_showPanel = () => {
		key.setScope('');
	};

	/**
	 * @description 隐藏面板的时候
	 * @private
	 */
	_hidePanel = () => {
		window.FJEvent.dispatch('UPDATE_LOGIN_STATUS');
		key.setScope('default');
	};

	render() {
		let {
			loadForLocal,
			saveForLocal,
			isLogin,
			checkIsSave
		} = this.props;

		return (
			<FJHeader saveForLocal={saveForLocal}
			          loadForLocal={loadForLocal}
			          isLogin={isLogin}
			          onSignUp={this.onSignUp}
			          checkIsSave={checkIsSave}
			/>
		)
	}
}

const mapStateToProps = function (state) {
	return {
		isLogin: state.user.isLogin
	}
};

const mapDispatchToProps = function (dispatch) {
	return {
		saveForLocal: function () {
			FJCanvasStore.execute(FJCanvasStore.command.SAVE_FOR_LOCAL);
		},
		loadForLocal: function (zip) {
			dispatch(FJExportVideoAction.loadProjectForLocalAction(zip));
		},
		loadForOnline: function (data) {
			dispatch(FJExportVideoAction.loadProjectForOnlineAction(data));
		},
		setLoginStatus: function (value) {
			dispatch(FJUserAction.setLoginStatusAction(value));
		},
		checkIsSave: function (callback) {
			dispatch(FJSaveAction.checkIsSaveAction(callback))
		},
		dealCloudZone: function () {
			dispatch(FJCloudAction.dealCloudZoneAction())
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(FJHeaderContainer);
